<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit">
            <header>
                <figure><i class="icon icon-icon_person"></i></figure>
                <div>
                    <span class="breadcrumb">
                        Attribute <i class="icon icon-icon_arrow-right"></i> importation
                    </span>
                    <h1>Importation</h1>
                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="close()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <div>

                <div class="medias-uploads" v-if="uniqueId" v-bind:class="{active: internalValue.length == 0}">

                    <div class="input">
                        <input class="input" type="file" :id="uniqueId" @change="upload($event)" multiple="true">
                        <span class="icon icon-icon_picture"></span>
                    </div>

                    <ul class="listing">
                        <li v-for="(item, index) in internalValue">
                            <div class="image">
                                <img v-if="!item.url" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" height="auto"/>
                                <a :href="item.url" target="_blank" v-if="item.url" ><img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" v-bind:style="{ backgroundImage: 'url(' + item.url + ')' }" height="auto"/></a>
                                <span class="icon icon-icon_picture" v-if="!item.url"></span>
                                <button class="bt-remove" v-if="item.url" @click="remove(index)"><i class="icon icon-icon_close"></i></button>
                            </div>
                        </li>
                    </ul>

                </div>

            </div>

        </article>
    </div>
</template>
<script>

    import Service from './MediaService.js';
    import Import from '../../layouts/Import.vue';
    import {Api} from '../../Api.js'

    export default {
        extends: Import,
        data () {
            return {
                internalValue: [],
                uniqueId: null
            }
        },
        mounted: function(){
            let n = Math.floor(Math.random()*11);
            let k = Math.floor(Math.random()* 1000000);
            this.uniqueId = "file-upload-"+String.fromCharCode(n)+k;
        },
        methods:{
            getResource: function(){
                return {name: 'media', api: Service}
            },
            close: function(){
                this.$emit('refresh', this);
                this.back();
            },
            upload(e){

                var fileInput = document.getElementById( this.uniqueId );
                var data = new FormData();

                for(var i=0 ; i<fileInput.files.length ; i++){
                    data.append( 'files[]', fileInput.files[i] );
                }

                Api().post('media', data).then((response) => {

                    for(var i=0 ; i<response.data.length ; i++){
                        if( !this.isInArray(response.data[i].id) ){
                            this.internalValue.push( response.data[i] );
                        }
                    }

                    this.$emit('input', this.internalValue);
                })
            },
            isInArray(id){
                let check = false
                for(var i=0 ; i<this.internalValue.length ; i++){
                    if(this.internalValue[i].id == id){
                        check = true
                        break;
                    }
                }
                return check
            },
            remove(index){
                this.internalValue.splice(index, 1);
                this.$emit('input', this.internalValue);
            },
            get(){
                if( this.internalValue ){

                    Api().get('media/'+this.internalValue).then((response) => {
                        this.img = response.data.url
                    })
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.get()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/media/Import.vue